$(document).ready(function () {
	$('[data-toggle="input-counter"] .btn-minus, [data-toggle=input-counter] .btn-plus').click(function () {
		let $container = $(this).closest('[data-toggle="input-counter"]');
		let plus = $(this).hasClass('btn-plus');
		let $input = $container.find('input');
		let value = parseInt($input.val());
		let max = parseInt($input.attr('max'));

		if (plus) {
			if (!isNaN(max)) {
				if (value + 1 <= max) {
					$input.val(value+1);
				} else {
					var text = $container.data('max-text').replace(':cnt', max);
					if (text) alert(text);
				}
			} else {
				$input.val(value+1);
			}
		} else {
			if (value-1 > 0) {
				$input.val(value-1);
			}
		}

		$input.trigger('change-counter');

		return false;
	});
});